const nav = document.querySelector('.navigation');
const body = document.querySelector('body');
const header = document.querySelector('.header');
const navHeight = nav.getBoundingClientRect().height;

function updateNavClass(entries) {
  const [entry] = entries;
  if (!entry.isIntersecting) {
    nav.classList.remove('navigation--transparent');
  } else {
    nav.classList.add('navigation--transparent');
  }
}

const headerObserver = new IntersectionObserver(updateNavClass, {
  root: null,
  threshold: 0,
  rootMargin: `${navHeight}px`,
});

const navigation = {
  mobileToggleButton: null,
  mobileMenu: null,
  megaMenuLinks: null,

  init: function () {
    const self = this;
    if (nav.classList.contains('js-navigation-transparency')) {
      headerObserver.observe(header);
    }

    nav.classList.add('navigation--js-enabled');

    this.mobileToggleButton = document.querySelector(
      '.js-megamenu-mobile-toggle'
    );
    this.mobileMenu = document.getElementById('megamenu-mobile');
    this.megaMenuLinks = document.querySelectorAll('.js-megamenu-link');

    this.megaMenuLinks.forEach((button) => {
      button.addEventListener('click', function (event) {
        const megamenu = button.nextElementSibling;
        if (
          megamenu.classList.contains('megamenu') &&
          !button.parentElement.classList.contains('open')
        ) {
          self.closeAll();
          button.parentElement.classList.add('open');
          button.setAttribute('aria-expanded', 'true');
          nav.classList.toggle('navigation--open');
        } else {
          button.parentElement.classList.remove('open');
          button.setAttribute('aria-expanded', 'false');
          nav.classList.toggle('navigation--open');
        }
        event.preventDefault();
        return false;
      });
    });

    document.body.addEventListener('click', function (e) {
      if (window.innerWidth < 1056) return;
      if (!nav.classList.contains('navigation--open')) return;
      if (
        document.querySelector('.navigation__links').contains(e.target) ||
        document.querySelector('.megamenu').contains(e.target)
      ) {
        //console.log(e.target)
      } else {
        self.closeAll();
      }
    });

    /*     let timer;
    document.querySelectorAll('li.megamenu__link').forEach(el => {
      el.addEventListener("mouseover", function(event){
        self.closeAll();
        el.querySelector('.js-megamenu-link').setAttribute('aria-expanded', 'true');
        this.classList.add('open');
        clearTimeout(timer);
      });
      el.addEventListener("mouseout", function(event){
        timer = setTimeout(function(event){
          self.closeAll();
        }, 300);
      });
    }) */

    this.mobileToggleButton.addEventListener('click', function (event) {
      self.mobileMenu.classList.toggle('d-none');
      self.mobileToggleButton.classList.toggle('open');
      nav.classList.toggle('navigation--open');
      body.classList.toggle('js-no-scroll');
    });
  },

  closeAll() {
    const self = this;
    document
      .querySelectorAll('li.megamenu__link.open')
      .forEach((el) => el.classList.remove('open'));
    self.megaMenuLinks.forEach((el) =>
      el.setAttribute('aria-expanded', 'false')
    );
    nav.classList.remove('navigation--open');
  },
};

export default navigation;
